import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const SafetyComplianceWorkflowRoute: RouteType = {
  name: "Safety Compliance Workflow",
  path: "/workflows/safety-compliance",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Safety & Compliance Reporting",
      component: () => import("./SafetyComplianceWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SafetyComplianceWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const fieldActivityIssuesStore = rootStore.fieldActivityIssuesStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const documentManagementStore = rootStore.documentManagementStore as ServiceStore;

      await Promise.all([
        fieldActivityIssuesStore?.find(),
        userStore?.find(),
        documentManagementStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for safety compliance:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).safetyComplianceWorkflowStore;
    store?.reset();
  },
};

export default SafetyComplianceWorkflowRoute;